import { Injectable, Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { pluralKey } from '../utils/plural';

/**
 * Resolves a Phrase pluralised key (`zero`/`one`/`other`) for a given `count`
 * and returns the translated string.
 *
 * ```html
 * {{ 'page.qualification_profiles.employee_status.expired_count'
 *      | translatePlural: count : { number: count } }}
 * ```
 *
 */
@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'translatePlural',
  pure: false,
})
export class TranslatePluralPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  transform(
    base: string,
    count: number,
    params?: Record<string, unknown>,
  ): string {
    return this.translateService.instant(pluralKey(base, count), {
      count,
      ...params,
    });
  }
}
